import { ButtonEmphases } from '@thg-commerce/gravity-elements'
import {
  BreakpointArray,
  TextEntry,
  TextStyle,
} from '@thg-commerce/gravity-theme'
import { TextStyling } from '@thg-commerce/gravity-theme/typography/typography'
import { HorizontalAlignment } from '@thg-commerce/gravity-theme/alignments'
import { BorderValuesInterface } from '@thg-commerce/gravity-theme/elements/formgroup'

export type FilterButtonInterface = {
  emphasis: ButtonEmphases
  textStyle?: TextStyling
  border?: BorderValuesInterface
}

export type ProductListThemeInterface = {
  header: {
    horizontalAlignment: HorizontalAlignment
    marginBottomSpacing: number
    title: {
      textStyle: TextStyling
    }
  }
  readMoreSection: {
    numberOfLinesToShow: number
    marginBottomSpacing: number
  }
  totalResults: {
    textStyle: {
      entry: TextEntry
      style: TextStyle
    }
  }
  gridGap: number
  attributesInsetSpacing: BreakpointArray<number>
  productListContainerSpacing: BreakpointArray<number>
  productListIntroSectionSpacing: BreakpointArray<number>
  filterButton: FilterButtonInterface
  containerSpacing: BreakpointArray<number>
  introSectionSpacing: BreakpointArray<number>
  readMoreSpacing: BreakpointArray<number>
  sortBy: {
    chevronIcon: {
      svgPath: string
      viewBox: string
      width: string
      height: string
    }
  }
}

export const DEFAULT_PRODUCT_LIST_WIDGET_THEME: ProductListThemeInterface = {
  header: {
    horizontalAlignment: HorizontalAlignment.LEFT,
    marginBottomSpacing: 0,
    title: {
      textStyle: {
        entry: 'large2',
        style: 'alternate',
        transform: 'none',
        textDecoration: 'none',
        textColor: '#333333',
      },
    },
  },
  readMoreSection: {
    numberOfLinesToShow: 3,
    marginBottomSpacing: 0,
  },
  totalResults: {
    textStyle: {
      entry: 'small',
      style: 'alternate',
    },
  },
  gridGap: 4,
  attributesInsetSpacing: [0],
  productListContainerSpacing: [2, 4],
  productListIntroSectionSpacing: [0],
  filterButton: {
    emphasis: 'medium',
  },
  containerSpacing: [2, 4],
  introSectionSpacing: [0],
  readMoreSpacing: [0],
  sortBy: {
    chevronIcon: {
      svgPath: '',
      viewBox: '0 0 24 24',
      width: '24px',
      height: '24px',
    },
  },
}
